import AnalyticsHelper from '../../utils/analytics-helper';

export default class AccessoriesModal {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.configurator--accessories-modal');
        this.data = parent.data;
        this.car = parent.car;
        this.navigation = parent.navigation;
        this.close = this.el.querySelector('.modal-close');
        this.accessories = [...this.el.querySelectorAll('[data-accessory]')];
        this.colours = [...this.el.querySelectorAll('[data-colour]')];
        this.modalLinks = [...this.parent.el.querySelectorAll('.accessories-modal-link')];
        this.accordions = this.el.querySelectorAll('.accordion-heading-section');
        this.subAccordions = this.el.querySelectorAll('.subAccordion-heading');
        this.bind();
    }

    bind() {
        this.close.addEventListener('click', () => this.hide());
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
        this.accordions.forEach((el) => el.addEventListener('click', (e) => this.openAccordion(e)));
        this.subAccordions.forEach((el) => el.addEventListener('click', (e) => this.openSubAccordion(e)));
        this.modalLinks?.forEach((l) => l.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const activeSection = e.target.closest('[data-section]');
            window.scrollTo({
                behavior: 'smooth',
                top:
                    activeSection.getBoundingClientRect().top
                    - document.body.getBoundingClientRect().top,
            });
            this.show();
            AnalyticsHelper.push(l);
        }));
    }

    show() {
        this.accessories.forEach((a) => (!this.car.data().accessories.includes(a.dataset.accessory) ? a.classList.add('hide') : a.classList.remove('hide')));
        this.colours.forEach((a) => (a.dataset.colour && a.dataset.colour !== this.car.colour ? a.classList.add('hide') : a.classList.remove('hide')));
        this.el.showModal();
        this.el.querySelector('.modal-close').focus({ preventScroll: true });
    }

    openAccordion(e) {
        e.preventDefault();
        e.stopPropagation();
        const stepName = this.navigation.sectionName.split(' ')[1].toLowerCase();
        const el = e.target.closest('.accordion-heading-section');

        if (el.classList.contains('open')) {
            el.classList.remove('open');
            el.setAttribute('aria-expanded', 'false');
            this.analyticsPush(el, stepName, 'less', 'l');
        } else {
            el.classList.add('open');
            el.setAttribute('aria-expanded', 'true');
            this.analyticsPush(el, stepName, 'more', 'm');
        }
    }

    openSubAccordion(e) {
        e.preventDefault();
        e.stopPropagation();
        // e.target.closest('.subAccordion-heading').classList.toggle('open');
        const stepName = this.navigation.sectionName.split(' ')[1].toLowerCase();
        const el = e.target.closest('.subAccordion-heading');

        if (el.classList.contains('open')) {
            el.classList.remove('open');
            el.setAttribute('aria-expanded', 'false');
            this.analyticsPush(el, stepName, 'less', 'l');
        } else {
            el.classList.add('open');
            el.setAttribute('aria-expanded', 'true');
            this.analyticsPush(el, stepName, 'more', 'm');
        }
    }

    hide() {
        this.el.close();
    }

    analyticsPush(el, stepName, action, suffix) {
        AnalyticsHelper.template(el, {
            stepName, suffix, action, sectionName: this.navigation.sectionName,
        });
        AnalyticsHelper.push(el);
    }
}
